import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";
import { publicConfig } from "@lululemon/ecom-common/src/util/public-config";
import { trackEvent, EVENT_CATEGORY } from "@lululemon/mwa-analytics";
import { getListPrice, getSalePrice } from "../quick-view-modal";
/**
 * Taken from packages/ecom-pdp/src/components/purchase-attributes/purchase-attributes-util.js
 */
export const getErrorMessage = (
  sizeList = null,
  deliveryType = "",
  isErrorTypeSelectedSizeNotAvailable,
  isWarningTypeNoSizeSelected,
  isSoldOutInStore,
  bopisFulfillmentAB = false
) => {
  if (sizeList && !sizeList.length) {
    return "Sold out.";
  }

  if (isErrorTypeSelectedSizeNotAvailable) {
    return deliveryType === "PIS"
      ? "Not available for pick up."
      : "Sold out online.";
  }

  if (isWarningTypeNoSizeSelected) {
    return bopisFulfillmentAB
      ? "Please select a size for availability."
      : "Please select a size.";
  }
  if (isSoldOutInStore) {
    return "Sold out at nearby stores.";
  }
  return "";
};

export const getToast = (clickCallback) => ({
  message: (
    <span className="lll-text-body-1 lll-font-weight-medium">
      Item added to bag
    </span>
  ),
  action: (
    <LinkGenerator
      href={publicConfig.links.cart}
      className="lll-link-primary"
      onClick={clickCallback}
    >
      View
    </LinkGenerator>
  ),
});

/**
 * This function builds the payload of the data to be used for the analytics events.
 * @param {*} param0
 * @returns
 */
export const getProductData = ({
  selectedSku = {},
  selectedVariant = {},
  selectedSize,
  skus = [],
  product = {},
  productCategoryUnifiedId,
  parentCategoryUnifiedId,
  productUnifiedId,
  productId,
}) => {
  const isOnSale =
    selectedSku?.price?.onSale || selectedVariant?.price?.onSale || false;

  return [
    {
      skuList: [
        {
          price: {
            isSale: isOnSale,
            displaySale: getSalePrice({
              selectedSku,
              skus,
            }),
            displayRegular: getListPrice({
              selectedSKU: selectedSku,
              skus,
            }),
          },
          size: selectedSize || "",
          sku: selectedSku?.id || "",
        },
      ],
      name: {
        unified: product.name || "",
        localized: product.name || "",
      },
      categoryUnifiedId: productCategoryUnifiedId || parentCategoryUnifiedId,
      unifiedId: productUnifiedId || "",
      productId,
    },
  ];
};

/**
 * This function is to make sure all the DAO events are called with
 * the same structure.
 * @param {*} param0
 */
export const callSatelliteTracking = ({
  id,
  eventCategory = EVENT_CATEGORY.PRODUCT_INTERACTION,
  type = "",
  text = "",
  position = -1,
  totalCount = -1,
  evars = [],
  productList,
  ...otherInfo
}) => {
  const eventInfo = {
    component: {
      id,
      type,
      text,
      position,
      totalCount,
    },
    ...otherInfo,
  };
  if (productList) {
    eventInfo["collectionList"] = [
      {
        id,
        type,
        productList,
      },
    ];
  }
  if (evars) {
    eventInfo.attributes = [evars];
  }
  trackEvent(eventCategory, eventInfo);
};

/**
 * This function was taken from the original QuickViewModal, is used by
 * the useAddToBag hook in ./adapter-hooks.js to provide the necessary
 * information for the mutation.
 * @param {*} param0
 * @returns
 */
export const findSku = ({ skus, colorCode, size }) => {
  const matchingSku = skus.find(
    (sku) => sku.color.code === colorCode && sku.size === size
  );
  if (!matchingSku || !matchingSku.available) {
    throw Error(
      `Selected colorCode ${colorCode} and size ${size} is not available`
    );
  }
  return matchingSku;
};

/**
 * This function was taken from the original QuickViewModal
 * us used by the useAddToBag hook in ./adapter-hooks.js to map
 * the data in the format that is expected by the addToBag mutation.
 * @param {*} param0
 * @returns
 */
export const convertToDigitalDataCart = ({
  cartId,
  cartTotal,
  productName,
  productID,
  category,
  sku,
  skuData,
  color,
  colorVariant,
}) => {
  return {
    cartId,
    cartTotal,
    item: [
      {
        productName,
        productID,
        category,
        productInfo: {
          size: sku.size,
          color: color.name,
        },
        skuID: sku.id,
        quantity: 1,
        categoryId: "",
        categoryUnifiedId: "",
        price: colorVariant.price.salePrice ?? colorVariant.price.listPrice,
        onSale: colorVariant.price.onSale,
        fullPrice: colorVariant.price.listPrice,
        attributes: {
          hazmat: false,
          stockStatus: skuData.lowStockMessage,
        },
      },
    ],
  };
};
